import useQueryParamsHelper from "./useQueryParamsHelper";

const usePagination = () => {
    const {getQueryParams, setQueryParams, deleteSearchParams} = useQueryParamsHelper();

    const pageChange = (newPage: number) => {
        setQueryParams({page: newPage.toString()});
    };

    const pageLimitChange = (size: number) => {
        if (size > 0) {
            setQueryParams({perPage: size.toString(), page: '1'});
        } else {
            setQueryParams({page: '0'});
            deleteSearchParams('perPage');
        }

    };
    const currentPage = getQueryParams('page');
    const perPage = Number(getQueryParams('perPage')) || undefined;
    return {
        page: currentPage ? Number(currentPage) : undefined,
        pageChange, pageLimitChange, perPage
    }
}
export default usePagination